
import abi from "./contract/GlobalPool.json";

import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Buy2 from "./component/buy2";
import Buy3 from "./component/buy3";
import Buy4 from "./component/buy4";
import Buy5 from "./component/buy5";
import jQuery from "jquery";


import "./logo.png";
import "./Global.gif";
import "./2.png";
import "./3.png";
import "./4.png";
import "./5.png";
import "./6.png";
import "./7.png";
import "./8.png";
import "./9.png";
import "./10.png";
import "./copy.png";


import { useState, useEffect } from "react";
import { ethers } from "ethers";

function App() {

  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[auto,setAuto]=useState("None");
  const[auto1,setAuto1]=useState("None");
  const[auto2,setAuto2]=useState("None");
  const[auto3,setAuto3]=useState("None");
  const[auto4,setAuto4]=useState("None");
  const[auto5,setAuto5]=useState("None");
  const[auto6,setAuto6]=useState("None");
  const [tasks1,setTasks1] = useState([]);
  const[auto7,setAuto7]=useState("None");
  const[bonus,setBonus]=useState("None");
  const[bonus1,setBonus1]=useState("None");
  const[pack,setpackage]=useState("None");
  const[refer,setrefer]=useState("None");
const [tasks,setTasks] = useState([]);
const [total,setTotal]=useState("None");
const [req,setreq]=useState("None");
const [tt,settt]=useState("None");
const[dd,setDD]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[bonanza1,setBonanza1]=useState("None");

const[wid,setwid]=useState("None");


  useEffect(() => {
    const connectWallet = async () => {
      const contractAddress = "0x7bfe012eb877efd06071849cdb149e1258f6cdb8";
      const contractABI = abi.abi;
      const searchParams = new URLSearchParams(window.location.search);
      const myParam = searchParams.get('ref');
      console.log(myParam);
      
      
      document.querySelector("#name").value=myParam;
  if(myParam == null)
  {
    document.querySelector("#name").value="0xE2767A23D4f40C7F832F1E5C8010C4cCF0D6bB4C";
  }
  
      try {
        const { ethereum } = window;
        document.querySelector("#test").value = "Upgrade USDT 100";
        if (ethereum) {
          const account = await ethereum.request({
            method: "eth_requestAccounts",
           
          });
         
          window.ethereum.on("chainChanged", () => {
            window.location.reload();
          });

          window.ethereum.on("accountsChanged", () => {
            
            window.location.reload();
          });

          const provider = new ethers.providers.Web3Provider(ethereum);
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
          document.querySelector("#us").value  = account[0];
          let alltasks = await contract.getMemos(account[0]);
          setTasks(alltasks);
           let alltasks1 = await contract.getMemos1(account[0]);
          setTasks1(alltasks1);

          const b =Number(alltasks[2]);
          const refer = (alltasks[1]);
         setrefer(refer);
         document.querySelector("#hid").value  = (alltasks[1]);
         const direct =Number(alltasks[2]);
         setDirect(direct);
         const directs =  Number(alltasks[22])/1000000000000000000;
         setDirects(directs);
         const level = Number(alltasks[23])/1000000000000000000;
         setLevel(level);
         const auto = Number(alltasks[11])/1000000000000000000;
         setAuto(auto);
         const auto1 = Number(alltasks[12])/1000000000000000000;
         setAuto1(auto1);
         const auto2 = Number(alltasks[13])/1000000000000000000;
         setAuto2(auto2);
         
         const auto3 = Number(alltasks[14])/1000000000000000000;
         setAuto3(auto3);
         
         const auto4 = Number(alltasks[15])/1000000000000000000;
         setAuto4(auto4);
         const auto5 = Number(alltasks[15])/1000000000000000000;
         setAuto5(auto5);
         const auto6 = Number(alltasks[16])/1000000000000000000;
         setAuto6(auto6);
        

         
         
         
         
         
         const bonus = Number(alltasks[18]);
         setBonus(bonus);
         const bonus1 = Number(alltasks[19]);
         setBonus1(bonus1);
         const total = Number(alltasks[10]);
         setTotal(total);

         const tt = directs + level + bonus + auto + total + auto1 + auto2 + auto3 + auto4 + auto5 + auto6  + bonus1;
         settt(tt);
         
         const pack = Number(alltasks[6]);
         document.querySelector("#pp").value  = Number(alltasks[6]);
         
    
    setpackage(pack);
    const bonanza = Number(alltasks[7]);
         setBonanza(bonanza);
         const bonanza1 = Number(alltasks[20]);
         setBonanza1(bonanza1);
         
         
    const dd = new Date(alltasks[8].timestamp * 1000).toLocaleString();
    setDD(dd);
         setB(b);
         const referlink = 'https://bvtpro.top/?ref='+ account;
         setreflink(referlink);
         document.querySelector("#link").value =referlink;
    if(pack==100)
    { 
      document.querySelector("#test").value = "Upgrade USDT 150";
    
    }
    else if(pack==250)
    { 
      document.querySelector("#test").value = "Upgrade USDT 250";
    
    }
    else if(pack ==500)
    {
      document.querySelector("#test").value = "Upgrade USDT 500";
    }
    else if(pack ==1000)
    {
      
      document.querySelector("#test").value = "Upgrade USDT 1000";
    }
    else if(pack ==2000)
    {
      document.querySelector("#test").value = "Upgrade USDT 2000";
    }
    
    else if(pack ==4000)
    {
      document.querySelector("#test").value = "Upgrade USDT 4000";
    }
    else if(pack ==8000)
    {
      document.querySelector("#test").value = "Upgrade USDT 8000";
    }
    else if(pack ==16000)
    {
      document.querySelector("#test").value = "Upgrade USDT 12000";
    }
    else if(pack ==28000)
    {
      document.querySelector("#test").value = "Upgrade USDT 16000";
    }
    else if(pack == 44000)
    {

      document.querySelector("#test").value = "All Packages Purchased";
    }
     const auto7 = Number(alltasks1[0]) - 1;
         setAuto7(auto7);
    console.log(pack);
    
     
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
     
    
    
    connectWallet();
    
  }, []);

 
  // console.log(state);
        
       
  return (
   
<div >
<input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    
    <section className="tv-service-section style-2 bg-light">
  <div className="tv-service-inner space-top position-relative overflow-hidden mx-30 ml-mx-0">
    
    <div className="p-top-left">
      <img src="assets/images/service/hm2-shape01.webp" alt="" />
    </div>

    <div className="p-top-right">
      <img src="assets/images/service/hm2-shape02.webp" alt="" />
    </div>

    <div className="bg image">
      <img src="assets/images/service/hm2-bg01.webp" alt="" />
    </div>

    <div className="container">

      {/* Section Title */}
      <div className="row mb-30">
        <div className="col-lg-12 text-center">
          <div className="title-wrap two white">
            <div className="sub-title-2 text-white two">
              <i className="fa-solid fa-circle-check"></i>
              Ecosystem Features
            </div>

            <h2 className="sec-title">
              Empowering Individuals with Reliable <br />
              and Sustainable Web3 Solutions
            </h2>
          </div>
        </div>
      </div>

      <div className="row g-4 justify-content-center">

        {/* Service Item 1 */}
        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "20px 16px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="48"
                  height="48"
                  fill="none"
                >
                  <defs>
                    <linearGradient
                      id="bvtGradient"
                      x1="0%"
                      y1="0%"
                      x2="100%"
                      y2="100%"
                    >
                      <stop offset="0%" stopColor="#1053f3" />
                      <stop offset="100%" stopColor="#00f2fe" />
                    </linearGradient>
                  </defs>

                  <path
                    d="M12 2L2 7l10 5 10-5-10-5z"
                    fill="url(#bvtGradient)"
                    opacity="0.85"
                  />

                  <path
                    d="M2 17l10 5 10-5M2 12l10 5 10-5"
                    stroke="url(#bvtGradient)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <circle
                    cx="12"
                    cy="11"
                    r="3"
                    fill="#ffffff"
                    filter="drop-shadow(0px 0px 8px #00f2fe)"
                  />
                </svg>
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
                <br />
               Total Joinings
              </h4>

              <p className="text"> {auto7}</p>
            </div>
          </div>
        </div>

        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "24px 22px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <img
                  src="assets/images/service/details-icon02.webp"
                  alt=""
                />
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
                <input type ="text" style={{backgroundColor: " #15205d" ,color:"white" , textAlign:"center", border :"0" ,width:"100%"} }id ="test"></input>
              </h4>

              <p className="text">
              <Buy state={state} />
              </p>
            </div>
          </div>
        </div>
      

        {/* Service Item 5 */}
        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "24px 22px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <img
                  src="assets/images/service/details-icon02.webp"
                  alt=""
                />
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
               My Total Packages
              </h4>

              <p className="text">
                USDT {pack}
              </p>
            </div>
          </div>
        </div>

        {/* Service Item 6 */}
        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "24px 22px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <img
                  src="assets/images/service/details-icon03.webp"
                  alt=""
                />
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
                My Direct Income 
              </h4>

              <p className="text">
               USDT {directs}
              </p>
            </div>
          </div>
        </div>
         
           {/* Service Item 1 */}
        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "20px 16px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="48"
                  height="48"
                  fill="none"
                >
                  <defs>
                    <linearGradient
                      id="bvtGradient"
                      x1="0%"
                      y1="0%"
                      x2="100%"
                      y2="100%"
                    >
                      <stop offset="0%" stopColor="#1053f3" />
                      <stop offset="100%" stopColor="#00f2fe" />
                    </linearGradient>
                  </defs>

                  <path
                    d="M12 2L2 7l10 5 10-5-10-5z"
                    fill="url(#bvtGradient)"
                    opacity="0.85"
                  />

                  <path
                    d="M2 17l10 5 10-5M2 12l10 5 10-5"
                    stroke="url(#bvtGradient)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <circle
                    cx="12"
                    cy="11"
                    r="3"
                    fill="#ffffff"
                    filter="drop-shadow(0px 0px 8px #00f2fe)"
                  />
                </svg>
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
                <br />
               My Direct Team
              </h4>

              <p className="text">{direct}</p>
            </div>
          </div>
        </div>

        {/* Service Item 2 */}
        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "24px 22px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <img
                  src="assets/images/service/hm1-icon02.webp"
                  alt=""
                />
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
                Total Income
              </h4>

              <p className="text">USDT {level}</p>
            </div>
          </div>
        </div>

        {/* Service Item 3 */}
        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "24px 22px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <img
                  src="assets/images/service/hm1-icon03.webp"
                  alt=""
                />
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
              level - I Income
              </h4>

              <p className="text">USDT {auto}</p>
            </div>
          </div>
        </div>

        {/* Service Item 4 */}
        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "24px 22px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <img
                  src="assets/images/service/details-icon01.webp"
                  alt=""
                />
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
              level - II Income
              </h4>

              <p className="text">
                USDT {auto1}
              </p>
            </div>
          </div>
        </div>

        {/* Service Item 5 */}
        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "24px 22px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <img
                  src="assets/images/service/details-icon02.webp"
                  alt=""
                />
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
               Level - III Income
              </h4>

              <p className="text">
                 USDT {auto2}
              </p>
            </div>
          </div>
        </div>

        {/* Service Item 6 */}
        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "24px 22px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <img
                  src="assets/images/service/details-icon03.webp"
                  alt=""
                />
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
               Level - IV Income
              </h4>

              <p className="text">
               USDT {auto3}
              </p>
            </div>
          </div>
        </div>
          {/* Service Item 1 */}
        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "20px 16px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="48"
                  height="48"
                  fill="none"
                >
                  <defs>
                    <linearGradient
                      id="bvtGradient"
                      x1="0%"
                      y1="0%"
                      x2="100%"
                      y2="100%"
                    >
                      <stop offset="0%" stopColor="#1053f3" />
                      <stop offset="100%" stopColor="#00f2fe" />
                    </linearGradient>
                  </defs>

                  <path
                    d="M12 2L2 7l10 5 10-5-10-5z"
                    fill="url(#bvtGradient)"
                    opacity="0.85"
                  />

                  <path
                    d="M2 17l10 5 10-5M2 12l10 5 10-5"
                    stroke="url(#bvtGradient)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <circle
                    cx="12"
                    cy="11"
                    r="3"
                    fill="#ffffff"
                    filter="drop-shadow(0px 0px 8px #00f2fe)"
                  />
                </svg>
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
                <br />
              Silver Royalty
              </h4>

              <p className="text">USDT {auto5}</p>
            </div>
          </div>
        </div>

        {/* Service Item 2 */}
        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "24px 22px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <img
                  src="assets/images/service/hm1-icon02.webp"
                  alt=""
                />
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
               Single Leg Income
              </h4>

              <p className="text">USDT {auto6}</p>
            </div>
          </div>
        </div>

        {/* Service Item 3 */}
        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "24px 22px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <img
                  src="assets/images/service/hm1-icon03.webp"
                  alt=""
                />
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
               Current Week Direct
              </h4>

              <p className="text"> {bonus}</p>
            </div>
          </div>
        </div>

        {/* Service Item 4 */}
        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "24px 22px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <img
                  src="assets/images/service/details-icon01.webp"
                  alt=""
                />
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
               Current Week Team
              </h4>

              <p className="text">
               {bonus1}
              </p>
            </div>
          </div>
        </div>

        {/* Service Item 5 */}
  {/* Service Item 2 */}
        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "24px 22px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <img
                  src="assets/images/service/hm1-icon02.webp"
                  alt=""
                />
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
                Welcome To BVTPRO :
              </h4>

              <p className="text">Connected Account: {account} </p>
            </div>
          </div>
        </div>

        {/* Service Item 3 */}
        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "24px 22px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <img
                  src="assets/images/service/hm1-icon03.webp"
                  alt=""
                />
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
                Refer Link
              </h4>

           <p className="valuation">{referlink}<button><img src ="copy.png" height={"20px"} width={"20px"} onClick={() => {
  navigator.clipboard.writeText(referlink);}} /></button></p>
            </div>
          </div>
        </div>

        {/* Service Item 4 */}
        <div className="col-xl-4 col-lg-6 col-md-6 col-12">
          <div
            className="tv-service-single-box"
            style={{
              padding: "24px 22px",
              borderRadius: "16px",
            }}
          >
            <div
              className="inner-box"
              style={{ textAlign: "center" }}
            >
              <div
                className="icon"
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto 14px auto",
                }}
              >
                <img
                  src="assets/images/service/details-icon01.webp"
                  alt=""
                />
              </div>

              <h4
                className="title"
                style={{
                  fontSize: "25px",
                  lineHeight: "26px",
                  marginTop: "0",
                }}
              >
                My Refer : 
              </h4>

              <p className="text">
                {refer}
              </p>
            </div>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</section>
                       
    </div>                      
    
 

  );
}

export default App;
